export default __webpack_public_path__ + "assets/img/placeholder-d0323d4c16cbadbc35756482d9bb67cf.webp";